import React from 'react';

const Backdrop = ({
    visible,
    closeShowMiniModal
}) => {
    if (!visible) {
        return null;
    }

    return (
        <button
            type="button"
            className="siteBackdrop"
            onClick={closeShowMiniModal}
            aria-label="Закрыть"
        />
    );
};

export default Backdrop;